"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _membership_type = _interopRequireDefault(require("./membership_type"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Membership = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_membership_type["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function Membership() {
    var _this;
    _classCallCheck(this, Membership);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Membership, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "name", _descriptor2, _this);
    _initializerDefineProperty(_this, "title", _descriptor3, _this);
    _initializerDefineProperty(_this, "descriptionUsd", _descriptor4, _this);
    _initializerDefineProperty(_this, "descriptionEur", _descriptor5, _this);
    _initializerDefineProperty(_this, "position", _descriptor6, _this);
    _initializerDefineProperty(_this, "costUsd", _descriptor7, _this);
    _initializerDefineProperty(_this, "costMonthlyUsd", _descriptor8, _this);
    _initializerDefineProperty(_this, "costEur", _descriptor9, _this);
    _initializerDefineProperty(_this, "costMonthlyEur", _descriptor10, _this);
    _initializerDefineProperty(_this, "active", _descriptor11, _this);
    _initializerDefineProperty(_this, "icon", _descriptor12, _this);
    _initializerDefineProperty(_this, "highlight", _descriptor13, _this);
    _initializerDefineProperty(_this, "highlightText", _descriptor14, _this);
    _initializerDefineProperty(_this, "position", _descriptor15, _this);
    _initializerDefineProperty(_this, "default", _descriptor16, _this);
    _initializerDefineProperty(_this, "recurring", _descriptor17, _this);
    _initializerDefineProperty(_this, "stripeEurTestPlanId", _descriptor18, _this);
    _initializerDefineProperty(_this, "stripeEurLivePlanId", _descriptor19, _this);
    _initializerDefineProperty(_this, "stripeUsdTestPlanId", _descriptor20, _this);
    _initializerDefineProperty(_this, "stripeUsdLivePlanId", _descriptor21, _this);
    _initializerDefineProperty(_this, "paypalEurTestPlanId", _descriptor22, _this);
    _initializerDefineProperty(_this, "paypalEurLivePlanId", _descriptor23, _this);
    _initializerDefineProperty(_this, "paypalUsdTestPlanId", _descriptor24, _this);
    _initializerDefineProperty(_this, "paypalUsdLivePlanId", _descriptor25, _this);
    _initializerDefineProperty(_this, "stripeUsdOneTimeLivePlanId", _descriptor26, _this);
    _initializerDefineProperty(_this, "stripeEurOneTimeLivePlanId", _descriptor27, _this);
    _initializerDefineProperty(_this, "stripeUsdOneTimeTestPlanId", _descriptor28, _this);
    _initializerDefineProperty(_this, "stripeEurOneTimeTestPlanId", _descriptor29, _this);
    _initializerDefineProperty(_this, "numberMonths", _descriptor30, _this);
    _initializerDefineProperty(_this, "membershipGroupId", _descriptor31, _this);
    _initializerDefineProperty(_this, "stripeAccount", _descriptor32, _this);
    _initializerDefineProperty(_this, "paypalAccount", _descriptor33, _this);
    _initializerDefineProperty(_this, "androidSubscriptionId", _descriptor34, _this);
    _initializerDefineProperty(_this, "iosSubscriptionId", _descriptor35, _this);
    _initializerDefineProperty(_this, "imageUrl", _descriptor36, _this);
    _initializerDefineProperty(_this, "membershipTypeId", _descriptor37, _this);
    _initializerDefineProperty(_this, "podcastAccess", _descriptor38, _this);
    _initializerDefineProperty(_this, "membershipGroupName", _descriptor39, _this);
    _initializerDefineProperty(_this, "membershipType", _descriptor40, _this);
    return _this;
  }
  _inherits(Membership, _RootModel);
  return _createClass(Membership, [{
    key: "description",
    get: function get() {
      var _this$membershipType;
      return (_this$membershipType = this.membershipType) === null || _this$membershipType === void 0 ? void 0 : _this$membershipType.description;
    }
  }, {
    key: "descriptionMd",
    get: function get() {
      var _this$membershipType2;
      return (_this$membershipType2 = this.membershipType) === null || _this$membershipType2 === void 0 ? void 0 : _this$membershipType2.descriptionMd;
    }
  }, {
    key: "membershipTypeName",
    get: function get() {
      return this.membershipType ? this.membershipType.name : null;
    }
  }, {
    key: "formattedName",
    get: function get() {
      return "Seedlang ".concat(this.membershipType.name);
    }
  }, {
    key: "titleWithMembership",
    get: function get() {
      var _this$title;
      return (_this$title = this.title) !== null && _this$title !== void 0 && _this$title.includes('Membership') ? this.title : "".concat(this.title, " Membership");
    }
  }, {
    key: "costFormatted",
    value: function costFormatted(currency, quantity) {
      var cost = quantity ? quantity * this.cost(currency) : this.cost(currency);
      return (0, _utils.amountWithCurrency)(cost / 100, currency);
    }
  }, {
    key: "costMonthly",
    value: function costMonthly(currency) {
      return this.numberMonths === 0 ? 0 : Math.floor(this.cost(currency) / this.numberMonths);
    }
  }, {
    key: "cost",
    value: function cost(currency) {
      return (currency === null || currency === void 0 ? void 0 : currency.toUpperCase()) === 'USD' ? this.costUsd : this.costEur;
    }
  }, {
    key: "discountPercentage",
    value: function discountPercentage(memberships, currency) {
      var _this2 = this;
      if (!this || this.numberMonths <= 1) return;
      var compareMembership = memberships === null || memberships === void 0 ? void 0 : memberships.find(function (item) {
        return item.numberMonths === 1 && item.membershipTypeId === _this2.membershipTypeId;
      });
      if (!compareMembership) return;
      var currentMonthlyCost = this.costMonthly(currency);
      var compareMonthlyCost = compareMembership.costMonthly(currency);
      return Math.floor((compareMonthlyCost - currentMonthlyCost) / compareMonthlyCost * 100);
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "title", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "descriptionUsd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "descriptionEur", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "costUsd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "costMonthlyUsd", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "costEur", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "costMonthlyEur", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "active", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "icon", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "highlight", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "highlightText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "default", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "recurring", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "stripeEurTestPlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "stripeEurLivePlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "stripeUsdTestPlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "stripeUsdLivePlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "paypalEurTestPlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "paypalEurLivePlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "paypalUsdTestPlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "paypalUsdLivePlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "stripeUsdOneTimeLivePlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "stripeEurOneTimeLivePlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "stripeUsdOneTimeTestPlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "stripeEurOneTimeTestPlanId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "numberMonths", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "membershipGroupId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "stripeAccount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "paypalAccount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "androidSubscriptionId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "iosSubscriptionId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "membershipTypeId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "podcastAccess", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "membershipGroupName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "membershipType", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "description", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "descriptionMd", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "descriptionMd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "membershipTypeName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "membershipTypeName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "titleWithMembership", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "titleWithMembership"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "costFormatted", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "costFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "costMonthly", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "costMonthly"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cost", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "cost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "discountPercentage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "discountPercentage"), _class.prototype), _class);
var _default = exports["default"] = Membership;